<template>
  <div class="b_nav" >
    <Menu :theme="theme2" mode="vertical" active-name="1" class="nav">
        <MenuItem name="1" to="/">
                首页
        </MenuItem>
        <MenuItem name="2" to="/technical/mob_list">
                技术服务
        </MenuItem>
        <MenuItem name="3" to="/products/mob_list">
                产品展示
        </MenuItem>
        <MenuItem name="4" to="/solution/mob_list">
                解决方案
        </MenuItem>
        <Submenu name="5">
            <template slot="title">
                关于我们
            </template>
                <MenuItem name="5-1" to="/intros/mob_list">企业介绍</MenuItem>
                <MenuItem name="5-2" to="/contact-info">联系我们</MenuItem>
        </Submenu>
    </Menu>
  </div>
</template>
<script>
export default {
  name: 'Aside',
  data () {
    return {
      theme2: 'light'
    }
  }
}
</script>
<style scoped>
  .b_nav {
    background: #2F669A;
    width: 100%;
  }
  .nav {
    margin: 0 auto;
  }
  .ivu-menu-primary {
    background: #2F669A;
  }
  .ivu-menu-horizontal {
    height: 72px;
    font-size: 14px;
  }
  .ivu-menu-submenu {
    height: 72px;
    line-height: 72px;
    font-size: 14px;
  }
  .ivu-menu-item {
    height: 72px;
    line-height: 72px;
    padding: 0px 50px;
    font-size: 14px;
  }
</style>
